<template>
    <div class="page-content">
        <SketchBreadcrumb pageName="Tutorial aplicare"></SketchBreadcrumb>
        <div class="padding-box">
            <div class="white-box">
                <div class="title-div">
                    <h3>Tutorial aplicare</h3>
                </div>
                <div class="tutorials-box">
                    <div class="flex flex-column align-center">
                        <b-icon-info-circle font-scale="3" class="mb-3"></b-icon-info-circle>
                        <p>Încă lucrăm la această funcționalitate! Va fi gata odată cu lansarea oficială a aplicației 411<strong>POC</strong> Sketch.</p>
                        <p class="mt-5">Poți alege una din paginile de mai jos:</p>
                        <ul>
                            <li><router-link to="/aplicatii/m3-sketch/compania-mea">Compania Mea</router-link></li>
                            <li><router-link to="/aplicatii/m3-sketch/checklist">Checklist</router-link></li>
                            <li><router-link to="/aplicatii/m3-sketch/sinteza">Sinteză proiect</router-link></li>
                            <li><router-link to="/aplicatii/m3-sketch/achizitii-cheltuieli">Achiziții / cheltuieli</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { BIconInfoCircle } from "bootstrap-vue";
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
    export default {
        components: {
            BIconInfoCircle,
            SketchBreadcrumb
        },
        data(){
            return{
            }
        },
        mounted() {
            this.$store.dispatch('pageLoading/setLoading', false)
        }
    }
</script>

<style scoped>
.title-div{
    margin-bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
}
.title-div h3{
    font-size: 25px;
    color:#aa93a8;
}
.white-box{
    background: #fff;
    padding: 20px;
}
.flex{
    display: flex;
}
.flex-column{
    flex-direction: column;
}
p{
    font-size: 14px;
}

ul{
    display: flex;
    justify-content: center;
	gap: 10px;
    margin-top: 10px;
    width: 100%;
}
ul li a{
    font-size: 13px;
    background-image: linear-gradient(to bottom, #8c6984, #816e8b);
    color: #fff;
    border-radius: 3px;
    box-sizing: border-box;
    padding: 5px 7px;
    white-space: nowrap;
    text-align: center;
}
li a:hover{
    text-decoration: none;
}
</style>
